import Page from './Page';

export default Page;



// WEBPACK FOOTER //
// ./src/containers/Page/index.js